/**
 * Шина событий биллинга. Используется, чтобы интерсептор API мог
 * сигнализировать UI-баннеру о нулевом балансе сразу, как только бэк
 * вернул 402, без необходимости отдельного запроса баланса. Также
 * сигнализирует о том, что баланс мог измениться после успешного
 * запуска модуля — UI должен перетянуть актуальное значение.
 */

export interface NoBalanceDetail {
  code?: string;
  message?: string;
}

export const NO_BALANCE_EVENT = "billing:no-balance";
export const BALANCE_CHANGED_EVENT = "billing:balance-changed";

export function dispatchNoBalance(detail: NoBalanceDetail = {}): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<NoBalanceDetail>(NO_BALANCE_EVENT, { detail }));
}

/**
 * Сообщить UI, что баланс мог измениться. Слушатели (например, виджет
 * баланса в Sidebar) должны заново вызвать `getBillingBalance`.
 *
 * Шлётся API-клиентом после успешного запуска любого платного модуля
 * через unified executor. Дешевле, чем городить broadcast-канал на бэке;
 * актуально для конкретной вкладки.
 */
export function dispatchBalanceChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(BALANCE_CHANGED_EVENT));
}
